const variants = {
  default: 'bg-surface text-text border-border',
  success: 'bg-success-bg text-success border-success/20',
  warning: 'bg-warning-bg text-warning border-warning/20',
  danger: 'bg-danger-bg text-danger border-danger/20',
  primary: 'bg-primary-light text-primary border-primary/20',
};

export function Badge({ children, variant = 'default', className = '' }) {
  return (
    <span className={`inline-flex max-w-full items-center rounded-full border px-2.5 py-0.5 text-xs font-medium leading-tight ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}
